import styled from 'styled-components';

import {toastNotificationsColors, commonPalette} from 'styles/palette';
import {TOAST_NOTIFICATIONS_TYPES} from 'enums';

const {darkGrey, red} = toastNotificationsColors;
const {white} = commonPalette;

const {SUCCESS} = TOAST_NOTIFICATIONS_TYPES;

export const ToastNotification = styled.div`
  padding: 15px;
  background-color: ${({type}) => (type === SUCCESS ? darkGrey : red)};
  cursor: pointer;
  margin: 10px 20px;
  color: ${white};
  border-radius: 5px;
  font-size: 14px;
  min-width: 200px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
`;
